<div class="loading" [class.hide]="loaded">
    <div class="loading-container h-100 w-100">
        <div class="shimmer">
            <img src="assets/fulllogo.png" alt="Loading Dexio..." />
            <div class="text-center w-100" style="margin-top: -20%">
                <small>{{loadingStatus}}</small>
            </div>
        </div>
    </div>
</div>
<ng-content *ngIf="loaded"></ng-content>
